import type { WalletsTranslations } from "../interfaces/wallets";

export const walletsTranslations: WalletsTranslations = {
  page_eyebrow: "Mis billeteras",
  page_title_with_name: "Billeteras de {{name}}",
  page_subtitle: "{{count}} activas",
  export_balance_button: "Exportar balance",
  stat_usd_equivalent: "Equivalente USD",
  stat_active_countries: "Países activos",
  stat_crypto_networks: "Redes crypto",
  stat_open_movements: "Movimientos abiertos",
  section_active: "Activas",
  section_active_sub: "Ya puedes operar en estas monedas",
  card_status_active: "ACTIVA",
  card_status_frozen: "CONGELADA",
  card_status_closed: "CERRADA",
  card_available_label: "Disponible",
  card_frozen_reason_label: "Motivo",
  card_frozen_banner_title: "Operaciones nuevas bloqueadas",
  card_actions_aria: "Acciones de la billetera",
  card_menu_movements: "Ver movimientos",
  operation_link_opening: "Abriendo el movimiento en tu billetera…",
  card_menu_top_up: "Cargar saldo",
  card_menu_debit: "Descargar saldo",
  card_methods_label: "Métodos de carga y envío",
  card_methods_crypto: "Redes de carga y retiro",
  card_recent_activity: "Actividad reciente",
  card_recent_empty: "Sin movimientos recientes.",
  card_view_all: "Ver todo",
  card_action_load: "Recibir dinero",
  card_action_send: "Enviar dinero",
  card_action_receive_short: "Recibir",
  card_action_send_short: "Enviar",
  card_action_convert: "Convertir",
  card_action_pay_qr: "Pagar con QR",
  entry_payin_detected_wallet: "Recaudo en camino",
  entry_payin_confirmed_wallet: "Recaudo acreditado",
  entry_payout_reserve_wallet: "Dinero enviado",
  entry_payout_release_wallet: "Envío devuelto",
  entry_swap_wallet: "Conversión entre billeteras",
  entry_coloca_top_up_wallet: "Recarga de Coloca Payments",
  entry_coloca_debit_wallet: "Débito de Coloca Payments",
  entry_coloca_debit_cancelled_wallet: "Débito de Coloca Payments cancelado",
  card_action_load_unavailable:
    "Este corredor todavía no está habilitado para tu organización. Escríbele a tu ejecutivo de cuenta.",
  card_action_send_unavailable: "Envío no disponible para esta moneda",
  activate_cta: "Activar wallet",
  activate_title: "Activar wallet",
  activate_subtitle: "Elige la moneda para activar una nueva billetera.",
  activate_currency_label: "Moneda",
  activate_currency_placeholder: "Selecciona una moneda",
  activate_loading: "Cargando monedas…",
  activate_confirm: "Activar",
  activate_cancel: "Cancelar",
  activate_success: "Billetera activada.",
  activate_error: "No pudimos activar la billetera.",
  activate_all_active: "Ya activaste todas las monedas disponibles.",
  card_menu_delete: "Eliminar billetera",
  order_cta: "Ordenar",
  order_title: "Ordena tus billeteras",
  order_subtitle: "Arrastra o usa las flechas. Todo tu equipo las verá en este orden.",
  order_move_up_aria: "Subir {{currency}}",
  order_move_down_aria: "Bajar {{currency}}",
  order_moved_announcement: "{{currency}} ahora está en la posición {{position}}.",
  order_save: "Guardar orden",
  order_cancel: "Cancelar",
  order_saved: "Orden guardado.",
  order_save_error: "No pudimos guardar el orden.",
  delete_title: "¿Eliminar la billetera {{currency}}?",
  delete_desc: "No tiene saldo ni movimientos, así que no se pierde nada.",
  delete_point_list: "Deja de aparecer en tu lista de billeteras.",
  delete_point_reactivate: "Puedes volver a activarla cuando quieras desde «Activar wallet».",
  delete_point_incoming: "Si recibes dinero en {{currency}}, vuelve a aparecer sola.",
  delete_confirm: "Eliminar billetera",
  delete_cancel: "Cancelar",
  delete_success: "Billetera eliminada. Puedes volver a activarla cuando quieras.",
  delete_error: "No pudimos eliminar la billetera.",
  empty_activate_title: "Aún no tienes billeteras activas.",
  empty_activate_desc: "Activa tu primera billetera para empezar a recibir y enviar dinero.",
  empty_activate_cta: "Activar tu primera wallet",
  reader_title: "Billeteras por organización",
  reader_subtitle: "Selecciona una organización para ver sus billeteras.",
  reader_search_placeholder: "Buscar organización…",
  reader_change_org: "Cambiar organización",
  reader_no_orgs: "No se encontraron organizaciones.",
  reader_org_wallets_empty: "Esta organización no tiene billeteras activas.",
  overview_title: "Billeteras de clientes",
  overview_subtitle: "Cuánto debe respaldar Coloca en cada moneda y quién lo tiene.",
  overview_updated: "Actualizado {{time}}",
  overview_refresh: "Actualizar",
  overview_include_coloca: "Incluir Coloca",
  overview_include_coloca_hint:
    "Suma también las billeteras de Coloca Payments, que guardan plata propia y no de clientes.",
  overview_activate_for_org: "Activar para una organización",
  overview_back: "Volver al resumen",
  summary_held: "A respaldar",
  summary_available: "Disponible",
  summary_blocked: "Bloqueado",
  summary_pending: "Por confirmar",
  summary_wallets: "{{funded}} de {{wallets}} con saldo",
  summary_top_holder: "Mayor: {{name}} · {{share}}",
  summary_select_aria: "Ver solo las billeteras en {{currency}}",
  summary_footnote:
    "A respaldar = disponible + bloqueado (dispersiones en curso que aún no salen). «Por confirmar» son cobros detectados que todavía no llegan, y no suman.",
  summary_empty: "No hay billeteras con estos filtros.",
  summary_error: "No pudimos sumar los saldos.",
  filter_search_label: "Organización",
  filter_search_placeholder: "Nombre, email o id de la organización",
  filter_currency_label: "Moneda",
  filter_currency_all: "Todas las monedas",
  filter_status_label: "Estado",
  filter_status_all: "Todos los estados",
  status_active: "Activa",
  status_frozen: "Congelada",
  status_closed: "Cerrada",
  filter_sort_label: "Ordenar por",
  sort_held_desc: "Más saldo a respaldar",
  sort_held_asc: "Menos saldo a respaldar",
  sort_available_desc: "Más disponible",
  sort_pending_desc: "Más por confirmar",
  sort_last_movement_desc: "Movimiento más reciente",
  sort_created_desc: "Activadas más recientes",
  filter_with_balance: "Solo con saldo",
  filter_min_held: "A respaldar desde",
  filter_max_held: "Hasta",
  filter_range_needs_currency: "Elige una moneda para filtrar por monto.",
  filter_sort_grouped_hint:
    "Sin moneda elegida, el orden va dentro de cada moneda: montos de monedas distintas no se comparan.",
  filter_clear: "Limpiar filtros",
  col_organization: "Organización",
  col_currency: "Moneda",
  col_held: "A respaldar",
  col_share: "% de la moneda",
  col_status: "Estado",
  col_last_movement: "Último movimiento",
  col_actions: "Acciones",
  never_moved: "Sin movimientos",
  action_open_org: "Ver organización",
  table_total: "{{total}} billeteras",
  table_empty: "Ninguna billetera coincide con estos filtros.",
  table_empty_desc: "Prueba con otra moneda o quita «Solo con saldo».",
  table_empty_unfunded_one: "La billetera que coincide está en cero.",
  table_empty_unfunded_other: "Las {{count}} billeteras que coinciden están en cero.",
  table_empty_unfunded_desc:
    "«Solo con saldo» deja afuera las billeteras en cero, y una billetera en cero puede haber movido plata: su extracto lo muestra.",
  hidden_unfunded_note_one: "1 billetera en cero no se muestra por «Solo con saldo».",
  hidden_unfunded_note_other: "{{count}} billeteras en cero no se muestran por «Solo con saldo».",
  hidden_unfunded_show: "Mostrar billeteras en cero",
  rows_error: "No pudimos cargar las billeteras.",
  tab_wallets: "Billeteras de clientes",
  tab_providers: "Saldos en proveedores",
  coverage_title: "Cobertura por moneda",
  coverage_hint: "Lo que hay que respaldar en las billeteras contra lo que los proveedores reportan tener.",
  coverage_label: "Cobertura",
  coverage_held: "A respaldar",
  coverage_in_providers: "En proveedores",
  coverage_short: "Faltan",
  coverage_surplus: "Sobran",
  coverage_nothing_to_back: "Nada que respaldar",
  coverage_no_reading: "Sin lectura",
  coverage_partial: "Hay saldos de esta moneda que no se pudieron leer.",
  providers_title: "Por proveedor",
  providers_footnote:
    "Solo lo que cada proveedor reporta por API: no entran bóvedas, cuentas bancarias ni otros fondos de Coloca.",
  providers_refresh: "Leer de nuevo",
  providers_refresh_hint:
    "Consulta a cada proveedor ahora, sin esperar la lectura guardada de hasta un minuto.",
  providers_refresh_denied:
    "Leer de nuevo necesita permiso de escritura en pagos. Se muestran las últimas lecturas.",
  providers_empty: "No hay rutas activas con saldo para leer.",
  providers_error: "No pudimos leer los saldos de los proveedores.",
  float_col_account: "Cuenta",
  float_col_available: "Disponible",
  float_col_status: "Estado",
  float_col_read: "Leído",
  float_use_payout: "Envíos {{rail}}",
  float_use_payin: "Cobros {{rail}} por liquidar",
  float_status_OK: "Al día",
  float_status_STALE: "Desactualizado",
  float_status_UNAVAILABLE: "Sin lectura",
  float_status_UNSUPPORTED: "No expone saldo",
  recheck_running: "Revisando con los proveedores los pagos en curso…",
  recheck_done:
    "Pagos en curso revisados: {{settled}} pagados, {{rejected}} rechazados, {{stillOpen}} siguen en curso",
  recheck_none: "No hay pagos en curso por revisar",
  recheck_not_found: "{{count}} sin rastro en el proveedor (para revisar)",
  recheck_failed_some: "{{count}} no se pudieron consultar",
  recheck_failed: "No pudimos revisar los pagos en curso con los proveedores.",
  loading: "Cargando billeteras…",
  error_load: "No pudimos cargar tus billeteras.",
  retry: "Reintentar",
  refresh_aria: "Actualizar saldo",
  balance_hide_aria: "Ocultar saldos",
  balance_show_aria: "Mostrar saldos",
  tx_status_process: "En proceso",
  tx_op_payin: "Entrada",
  tx_op_payout: "Salida",
  tx_op_swap: "Intercambio",
  tx_op_fee: "Comisión",
  tx_op_adjust: "Recargas y ajustes",
  tx_op_coloca_top_up: "Recarga",
  tx_op_coloca_debit: "Débito",
  tx_op_coloca_debit_cancelled: "Débito cancelado",
  tx_op_reverse: "Reversión",
  statement_pending_label: "Pendiente",
  statement_blocked_label: "Bloqueado",
  statement_filter_op_all: "Todos los tipos",
  statement_filter_dir_all: "Todas las direcciones",
  statement_filter_dir_credit: "Entradas",
  statement_filter_dir_debit: "Salidas",
  pending_collections_title: "Cobros pendientes",
  pending_collections_count_one: "1 cobro",
  pending_collections_count_other: "{{count}} cobros",
  pending_collections_awaiting: "Esperando el pago",
  pending_collections_not_found: "No pudimos abrir ese cobro. Puede que ya no exista.",
  pending_collections_dismiss: "Entendido",
  statement_detail_date: "Fecha",
  statement_detail_type: "Tipo",
  statement_detail_rail: "Método de pago",
  statement_detail_beneficiary: "Destinatario",
  statement_detail_breb_key: "Llave Bre-B",
  statement_detail_breb_network_reference: "ID de transacción Bre-B",
  statement_detail_direction: "Dirección",
  statement_detail_amount: "Monto",
  statement_detail_balance_after: "Saldo resultante",
  statement_detail_status: "Estado",
  statement_detail_description: "Descripción",
  statement_detail_reference: "Referencia",
  statement_detail_origin: "Origen",
  statement_detail_concept: "Concepto",
  statement_detail_top_up_reference: "Referencia de la recarga",
  statement_detail_internal_note: "Nota interna",
  statement_detail_created_by: "Hecho por",
  statement_detail_debit_reference: "Referencia del débito",
  statement_detail_reversal: "Reversión",
  statement_detail_reversal_yes: "Sí",
  statement_detail_view_ledger: "Ver asientos contables",
  statement_filter_range: "Rango de fechas",
  statement_freeze: "Congelar",
  statement_unfreeze: "Descongelar",
  statement_freeze_title_wallet: "Congelar billetera {{currency}}",
  statement_freeze_intro: "Vas a bloquear operaciones nuevas de esta billetera.",
  statement_freeze_desc:
    "La billetera rechazará compromisos nuevos, pero completará las operaciones en curso.",
  statement_freeze_reason_label: "Motivo",
  statement_freeze_reason_placeholder: "Motivo del congelamiento",
  statement_freeze_confirm: "Congelar",
  statement_freeze_cancel: "Cancelar",
  statement_freeze_success: "Billetera congelada.",
  statement_freeze_error: "No pudimos congelar la billetera.",
  statement_unfreeze_title_wallet: "¿Descongelar billetera {{currency}}?",
  statement_unfreeze_clears_reason: "Se borrará el motivo registrado:",
  statement_unfreeze_desc: "La billetera volverá a aceptar operaciones.",
  statement_unfreeze_success: "Billetera descongelada.",
  statement_unfreeze_error: "No pudimos descongelar la billetera.",
  // Colombia deposit modal
  deposit_modal_title: "Cargar fondos",
  deposit_mode_received: "Lo que recibiré en mi billetera",
  deposit_mode_sent: "Monto que me van a transferir",
  deposit_amount_label: "¿Cuánto quieres cargar?",
  deposit_breakdown_title: "Desglose estimado",
  deposit_breakdown_pays: "Vas a pagar",
  deposit_breakdown_fee: "Comisión estimada",
  deposit_breakdown_credited: "Acreditamos aprox.",
  deposit_continue: "Continuar",
  deposit_edit_amount: "Editar monto",
  deposit_processing: "Procesando tu solicitud…",
  deposit_result_error: "No se pudo crear el cobro",
  deposit_retry: "Intentar de nuevo",
  deposit_new: "Crear otro cobro",
  deposit_close: "Cerrar",
  deposit_nequi_open: "Abrir pago",
  deposit_copy_link: "Copiar enlace",
  deposit_link_copied: "Enlace copiado",
  deposit_breb_key_label: "Llave Bre-B",
  deposit_copy_key: "Copiar llave",
  deposit_key_copied: "Llave copiada",
  deposit_result_fee_label: "Comisión",
  deposit_result_fee_free: "Gratis",
  deposit_verify_cta: "Ya envié, verificar",
  deposit_verify_checking: "Verificando…",
  deposit_verify_paid: "¡Pago recibido! Los fondos están en camino.",
  deposit_verify_pending: "Aún en proceso. Intenta en unos segundos.",
  deposit_verify_failed: "Pago no encontrado o rechazado.",
  // Brazil (PIX)
  deposit_pix_copia_label: "Código Pix (Copia e Cola)",
  deposit_pix_copy_code: "Copiar código",
  deposit_pix_code_copied: "Código copiado",
  // Colombia (Bre-B)
  // Colombia (PSE — débito bancario con redirección). El formulario del pagador, el paso al banco y sus
  // errores viven ahora en el namespace `payins` (`pse_*`), compartidos con la pestaña Colombia de
  // /app/payins; aquí solo quedan las filas que este modal pinta por su cuenta.
  deposit_method_pse: "PSE",
  deposit_pse_bank_label: "Banco",
  deposit_pse_doc_number_label: "Número de documento",
  deposit_pse_confirmed: "Pago confirmado — el saldo de la wallet fue acreditado.",
  // Colombia (Nequi push)
  deposit_nequi_waiting_title: "Revisa la app Nequi",
  deposit_nequi_waiting_body:
    "Enviamos la solicitud de cobro al número {{phone}}. Acepta el pago en la app Nequi para completar la recarga.",
  deposit_nequi_waiting_live: "Esperando la confirmación… puedes dejar esta ventana abierta.",
  deposit_payer_name_label: "Nombre del pagador",
  deposit_payer_name_placeholder: "Nombre y apellido",
  deposit_payer_doc_label: "CPF/CNPJ del pagador",
  deposit_payer_doc_placeholder: "Solo números",
  deposit_payer_hint: "Datos de quien hará el pago PIX; son necesarios para generar el QR.",
  deposit_error_no_org: "Tu usuario no tiene una organización asociada, no es posible crear el cobro.",
  // Mexico (SPEI/CLABE)
  deposit_clabe_label: "Cuenta CLABE",
  deposit_spei_clabe_label: "CLABE para este cobro",
  deposit_spei_hint:
    "Datos de quien hará la transferencia SPEI. Se asignará una CLABE exclusiva para este cobro, con vencimiento.",
  deposit_payer_rfc_label: "RFC del pagador (opcional)",
  deposit_payer_rfc_placeholder: "Puedes dejarlo vacío",
  deposit_clabe_copy: "Copiar CLABE",
  deposit_clabe_copied: "CLABE copiada",
  deposit_expires_label: "Vence el",
  // Shared confirm / result
  deposit_payment_created: "Cobro creado",
  deposit_result_id: "ID",
  deposit_confirm_amount: "Monto",
  deposit_confirm_method_row: "Método",
  deposit_edit: "Editar",
  deposit_create_payment: "Crear pago",
  deposit_you_receive: "Recibirás",
  deposit_payer_sends: "El pagador envía",
  deposit_receive_label: "Quieres recibir",
  deposit_paid_title: "Pago acreditado",
  deposit_paid_text: "El pagador completó la transferencia y el neto ya está en tu billetera.",
  deposit_verify_reversed: "El pago fue reversado: lo acreditado se descontó de tu billetera.",
  deposit_reversed_text:
    "Este pago se había acreditado y después fue reversado: lo acreditado se descontó de tu billetera. Puedes crear un nuevo depósito.",
  deposit_rejected_text: "El pago fue rechazado y no se acreditó. Puedes crear un nuevo depósito.",
  deposit_mode_gross_label: "Voy a pagar",
  deposit_mode_net_label: "Quiero recibir",
  deposit_mode_gross_hint: "Escribe lo que vas a transferir; te decimos cuánto se acredita.",
  deposit_mode_net_hint: "Escribe lo que quieres que se acredite; te decimos cuánto debes transferir.",
  deposit_derived_net_text:
    "Se acreditan {{amount}} {{currency}} en tu billetera, después de {{fee}} {{currency}} de comisión.",
  deposit_derived_gross_text:
    "Debes transferir {{amount}} {{currency}} para que se acredite completo, con {{fee}} {{currency}} de comisión.",
  deposit_pays: "Pagas",
  deposit_we_credit: "Acreditamos",
  deposit_confirm_name: "Nombre",
  // Colombia confirm section headers
  deposit_confirm_amount_method: "Monto y método",
  deposit_confirm_payer_data: "Datos del pagador",
  // Colombia confirm row labels
  deposit_confirm_document: "Documento",
  deposit_confirm_email_row: "Email",
  deposit_confirm_phone: "Teléfono",
  deposit_confirm_nequi: "Nequi",
  deposit_confirm_bank: "Banco",
  deposit_confirm_description: "Descripción",
  // Colombia form labels
  deposit_form_firstname: "Nombre",
  deposit_form_lastname: "Apellido",
  deposit_form_doc_type: "Tipo de documento",
  deposit_form_doc_number: "Número de documento",
  deposit_form_email: "Correo electrónico",
  deposit_form_description: "Descripción",
  deposit_form_bank: "Banco",
  deposit_form_nequi: "Número Nequi",
  // Colombia form placeholders
  deposit_form_firstname_placeholder: "Juan",
  deposit_form_lastname_placeholder: "Pérez",
  deposit_form_description_placeholder: "Concepto del cobro",
  deposit_form_bank_placeholder: "Selecciona tu banco",
  // Colombia method card
  deposit_method_filtered: "filtrado por monto",
  // Colombia result screen
  deposit_nequi_section: "Abre el pago Nequi",
  deposit_nequi_blocked: "Tu navegador bloqueó el popup. Copia el enlace o intenta de nuevo.",
  // Wallet statement (movements) view
  movements_hero_balance_label: "Saldo disponible",
  movements_stat_movement_singular: "movimiento",
  movements_stat_movement_plural: "movimientos",
  movements_filter_clear: "Limpiar",
  movements_group_today: "Hoy",
  movements_group_yesterday: "Ayer",
  movements_empty_no_data: "Esta wallet aún no tiene movimientos.",
  movements_empty_no_results: "Sin resultados con los filtros actuales.",
  movements_detail_label_external: "EXTERNO",
  movements_detail_label_internal: "INTERNO",

  deposit_back: "Volver",
  deposit_amount_section_title: "Cobrar un monto",
  deposit_amount_section_hint: "Genera un QR con monto o cobra por PSE, Nequi o Botón Bancolombia.",
  deposit_amount_input_label: "¿Cuánto vas a cobrar?",
  deposit_fee_switch: "Yo asumo la comisión",
  deposit_fee_on_hint:
    "El pagador transfiere el monto exacto; la comisión se descuenta de lo que llega a tu billetera.",
  deposit_fee_off_hint: "Recibes el monto completo; la comisión se suma a lo que transfiere el pagador.",
  deposit_row_fee: "Comisión",
  deposit_row_credited: "Llega a tu billetera",
  deposit_fee_free: "Sin costo",
  deposit_amount_hint_bra: "El pagador te transfiere por PIX desde cualquier banco de Brasil.",
  deposit_amount_hint_mex: "El pagador te transfiere por SPEI desde cualquier banco de México.",
  deposit_method_pix_hint: "Al instante, con QR o Pix Copia e Cola",
  deposit_method_spei_hint: "Transferencia a una CLABE creada solo para este cobro",
  deposit_payer_name_error: "Escribe el nombre de quien paga",
  deposit_payer_doc_error: "Escribe un CPF (11 dígitos) o un CNPJ (14 dígitos).",
  deposit_payer_doc_check_error: "Revisa el número: los dígitos verificadores no coinciden.",
  deposit_payer_rfc_error: "El RFC tiene como máximo 13 caracteres.",
  deposit_payer_rfc_short: "RFC",
  deposit_how_to_pay: "Cómo pagar",
  deposit_pix_waiting: "Esperando el pago",
  deposit_pix_expires_in: "Vence en {{time}}",
  deposit_pix_expired_title: "Este QR venció",
  deposit_pix_expired_text: "Ya no se puede pagar. Crea otro cobro para generar un QR nuevo.",
  deposit_pix_step_1: "Abre la app del banco y entra a Pix.",
  deposit_pix_step_2: "Escanea el QR o elige Pix Copia e Cola y pega el código.",
  deposit_pix_step_3: "Confirma el pago de {{amount}}. Lo acreditamos apenas llegue.",
  deposit_spei_waiting: "Esperando la transferencia",
  deposit_spei_exact_amount: "Monto exacto a transferir",
  deposit_spei_copy_amount: "Copiar monto",
  deposit_spei_amount_copied: "Monto copiado",
  deposit_spei_step_1: "En la banca en línea, crea una transferencia SPEI.",
  deposit_spei_step_2: "Usa esta CLABE y transfiere exactamente {{amount}}.",
  deposit_spei_step_3: "Lo acreditamos apenas llegue. La CLABE solo sirve para este cobro.",
  deposit_processing_pix: "Generando tu QR PIX…",
  deposit_processing_spei: "Generando la CLABE de este cobro…",
  statement_detail_copy_link: "Copiar enlace",
  statement_detail_link_copied: "Enlace copiado",
  statement_detail_copy_link_error: "No pudimos copiar el enlace. Copia la dirección del navegador.",
  statement_movement_not_found: "No encontramos ese movimiento en esta billetera.",
  // WhatsApp notifications for money in and out (/app/wallets/notifications). Catalogue only for now.
  notifications_eyebrow: "Billeteras · Recaudos y envíos",
  notifications_page_title: "Notificaciones por WhatsApp",
  notifications_page_subtitle:
    "Entérate por WhatsApp cuando entra o sale dinero de tus billeteras, sin tener que revisar la actividad: recaudos, envíos, pagos por lote y Bre-B.",
  notifications_hero_title: "Avisos cuando entra o sale dinero",
  notifications_hero_sub:
    "Un mensaje en el momento en que el pago se acredita o el envío se resuelve, con el monto, el medio y la referencia.",
  notifications_footnote:
    "Los avisos llegan al número que configures arriba, no al pagador ni al beneficiario.",
  notifications_recipient_hint: "Enviado al número de avisos de tu organización",
  notifications_recipient_label: "Número que recibe los avisos",
  notifications_recipient_help:
    "Por defecto es el celular de la verificación de tu organización. Cámbialo si quieres recibirlos en otro número.",
  notifications_recipient_help_custom:
    "Es el número que guardaste. Si lo borras, vuelven al celular de la verificación de tu organización.",
  notifications_recipient_missing:
    "Tu organización no tiene un celular registrado. Escribe el número que recibirá los avisos.",
  notifications_recipient_save: "Guardar número",
  notifications_threshold_label: "Avisar cuando el saldo baje de",
  notifications_threshold_help:
    "Un umbral por billetera. Se avisa una sola vez al bajar de él, hasta que el saldo vuelva a subir.",
  notifications_threshold_required_error: "Define al menos un umbral mayor a cero.",
  notifications_threshold_no_wallets: "Activa una billetera para definir su umbral.",
  notifications_enable_confirm_title: "¿Activar el aviso «{{name}}»?",
  notifications_enable_confirm_intro:
    "Coloca enviará este WhatsApp al número que recibe los avisos de tu organización cada vez que pase esto:",
  notifications_enable_confirm_reversible: "Puedes desactivarlo en cualquier momento.",
  notifications_enable_confirm_button: "Sí, activar",
  notifications_enable_confirm_cancel: "Cancelar",

  notifications_group_collections_title: "Recaudos",
  notifications_group_collections_desc:
    "Los demás medios: PSE, Nequi, Botón Bancolombia, Transfiya, PIX, SPEI, CBU/CVU y USDT.",
  notifications_group_payouts_title: "Envíos",
  notifications_group_payouts_desc:
    "Envíos uno por uno por PSE, Transfiya, PIX, SPEI, CBU/CVU o USDT, y el saldo de la billetera que los paga.",
  notifications_group_batches_title: "Pagos por lote",
  notifications_group_batches_desc:
    "Lotes cargados desde una planilla, desde que esperan aprobación hasta que terminan.",
  notifications_group_breb_title: "Bre-B",
  notifications_group_breb_desc:
    "Pagos que recibes con tu código QR o en tu llave, transferencias a una llave Bre-B y pagos de códigos QR de comercios.",

  notifications_payin_confirmed_name: "Pago recibido",
  notifications_payin_confirmed_desc:
    "El pago quedó acreditado en tu billetera, con lo que entró después de la comisión.",
  notifications_payin_rejected_name: "Pago no completado",
  notifications_payin_rejected_desc:
    "El banco rechazó el pago o llegó un monto distinto al esperado. No se avisa cuando un QR o un link solo vence.",
  notifications_payout_paid_name: "Envío pagado",
  notifications_payout_paid_desc:
    "El banco o la red confirmaron que el dinero llegó al beneficiario. Genera un mensaje por cada envío.",
  notifications_payout_failed_name: "Envío no completado",
  notifications_payout_failed_desc:
    "El banco del beneficiario lo rechazó o Coloca lo canceló. El dinero vuelve a tu billetera.",
  notifications_wallet_balance_low_name: "Saldo bajo",
  notifications_wallet_balance_low_desc:
    "El saldo de una billetera bajó del umbral que definas, para recargarla antes de que se detengan tus envíos.",
  notifications_batch_pending_name: "Lote por aprobar",
  notifications_batch_pending_desc:
    "Alguien de tu organización mandó un lote a aprobación y lo tiene que aprobar una segunda persona.",
  notifications_batch_completed_name: "Lote procesado",
  notifications_batch_completed_desc:
    "El lote terminó de ejecutarse, con cuántos pagos salieron y cuántos fallaron.",
  notifications_breb_payment_name: "Pago recibido por Bre-B",
  notifications_breb_payment_desc:
    "Te pagaron con tu código QR o en tu llave y el dinero ya está en tu billetera.",
  notifications_breb_paid_name: "Transferencia Bre-B exitosa",
  notifications_breb_paid_desc:
    "La entidad del destinatario confirmó la transferencia, con la llave y el titular.",
  notifications_breb_failed_name: "Transferencia Bre-B no completada",
  notifications_breb_failed_desc:
    "La llave no existe, está inactiva o la entidad la rechazó. El dinero vuelve a tu billetera COP.",
  notifications_breb_qr_payment_name: "Pago con QR Bre-B",
  notifications_breb_qr_payment_desc: "Tu organización pagó desde Coloca el código QR Bre-B de un comercio.",

  notifications_bubble_payin_confirmed_body:
    "Recibiste COP 1.250.000 por PSE.\nEmpresa: Tienda Viva SAS\nPagador: Laura Gómez Ríos\nAbonado a tu billetera: COP 1.241.250\n6 oct 2026 · 2:30 p. m. · Ref. 7F3A9C21\n\nYa está disponible en tu billetera.",
  notifications_bubble_payin_rejected_body:
    "Un pago de COP 480.000 por PSE no se completó.\nEmpresa: Tienda Viva SAS\nMotivo: El banco del pagador rechazó la transacción\nPagador: Carlos Pérez\n6 oct 2026 · 3:05 p. m. · Ref. C41D0B7E\n\nNo se abonó a tu billetera. Si tienes dudas, escríbenos por aquí.",
  notifications_bubble_payout_paid_body:
    "Tu envío de BRL 1.500,00 por PIX fue pagado.\nEmpresa: Tienda Viva SAS\nBeneficiario: Ana Souza\nDestino: Llave PIX •••• 8899\n6 oct 2026 · 11:20 a. m. · Ref. 9B12E0F4\n\nEl beneficiario ya recibió el dinero.",
  notifications_bubble_payout_failed_body:
    "Tu envío de COP 900.000 por Transfiya no se completó.\nEmpresa: Tienda Viva SAS\nMotivo: El banco o la red del beneficiario rechazó el envío\nBeneficiario: Jorge Ramírez\n6 oct 2026 · 4:10 p. m. · Ref. 2D7C55A0\n\nEl dinero volvió a tu billetera COP. Si tienes dudas, escríbenos por aquí.",
  notifications_bubble_wallet_balance_low_body:
    "Tu billetera COP bajó de COP 5.000.000.\nEmpresa: Tienda Viva SAS\nSaldo disponible: COP 3.250.000\n6 oct 2026 · 4:45 p. m.\n\nRecárgala para que tus próximos envíos no se detengan.",
  notifications_bubble_batch_pending_body:
    "El lote nomina-octubre-2026.xlsx espera aprobación.\nEmpresa: Tienda Viva SAS\nPagos: 120 · Total: COP 98.400.000\nMedio: Bre-B\nEnviado por: Andrés Molina\n\nEntra a Coloca para revisarlo y aprobarlo.",
  notifications_bubble_batch_completed_body:
    "Terminó de procesarse el lote nomina-octubre-2026.xlsx.\nEmpresa: Tienda Viva SAS\nEnviados: 118 de 120 · Fallidos: 2\nTotal enviado: COP 96.760.000\n\nEn Coloca puedes ver el detalle y reintentar los fallidos.",
  notifications_bubble_breb_payment_body:
    "Recibiste COP 85.000 por Bre-B con tu código QR.\nEmpresa: Tienda Viva SAS\nPagador: Valentina Cruz\nAbonado a tu billetera: COP 84.405\n6 oct 2026 · 12:10 p. m. · Ref. 4E8A1D93\n\nYa está disponible en tu billetera.",
  notifications_bubble_breb_paid_body:
    "Tu transferencia de COP 350.000 por Bre-B fue exitosa.\nEmpresa: Tienda Viva SAS\nLlave destino: 300 ••• 4567\nTitular: Cami••• Rest•••\n6 oct 2026 · 9:42 a. m. · Ref. A0F3C7B2\n\nEl titular ya recibió el dinero.",
  notifications_bubble_breb_failed_body:
    "Tu transferencia de COP 120.000 a la llave @ferr••• no se completó.\nEmpresa: Tienda Viva SAS\nMotivo: La llave no existe, está inactiva o la entidad la rechazó\n6 oct 2026 · 10:05 a. m. · Ref. 6C2B90DE\n\nEl dinero volvió a tu billetera COP. Si tienes dudas, escríbenos por aquí.",
  notifications_bubble_breb_qr_payment_body:
    "Pagaste COP 46.900 a Panadería San José con un código QR Bre-B.\nEmpresa: Tienda Viva SAS\n6 oct 2026 · 8:15 a. m. · Ref. 5D1E7A08\n\nSe descontó de tu billetera COP.",
  notifications_bubble_payin_confirmed_title: "Pago recibido",
  notifications_bubble_payin_rejected_title: "Pago no completado",
  notifications_bubble_payout_paid_title: "Envío pagado",
  notifications_bubble_payout_failed_title: "Envío no completado",
  notifications_bubble_wallet_balance_low_title: "Saldo bajo",
  notifications_bubble_batch_pending_title: "Lote por aprobar",
  notifications_bubble_batch_completed_title: "Lote procesado",
  notifications_bubble_breb_payment_title: "Pago recibido por Bre-B",
  notifications_bubble_breb_paid_title: "Transferencia Bre-B exitosa",
  notifications_bubble_breb_failed_title: "Transferencia Bre-B no completada",
  notifications_bubble_breb_qr_payment_title: "Pago con QR Bre-B",
  entry_card_top_up: "Recarga de tarjeta •••• {{last4}}",
  entry_card_top_up_reversal: "Devolución de recarga de tarjeta •••• {{last4}}",
  tx_op_card_top_up: "Recarga de tarjeta",
  tx_op_card_top_up_reversal: "Devolución de recarga de tarjeta",
  statement_detail_card: "Tarjeta",
  statement_detail_card_open: "Ver tarjeta",
  statement_detail_card_credited: "Llegó a la tarjeta",
  statement_detail_card_price: "Precio por dólar",
  tab_movements: "Movimientos",
  movements_presets_label: "Vistas rápidas",
  movements_preset_breb_paid: "Bre-B pagados",
  movements_preset_otc_processing: "OTC en proceso",
  movements_preset_open_incidents: "Novedades abiertas",
  movements_preset_refunded: "Reembolsados",
  movements_filter_search: "Buscar",
  movements_filter_search_placeholder: "Organización, beneficiario, llave, id o referencia (NOV-, CP-…)",
  movements_filter_organization: "Organización",
  movements_filter_organization_all: "Todas las organizaciones",
  movements_filter_organization_all_hint: "Movimientos de todas las organizaciones.",
  movements_filter_min: "Monto desde",
  movements_filter_max: "Monto hasta",
  movements_filter_days: "Días",
  movements_filter_days_placeholder: "Cualquier fecha",
  movements_filter_rail: "Riel",
  movements_filter_rail_all: "Todos los rieles",
  movements_filter_direction: "Dirección",
  movements_filter_status: "Estado del pago",
  movements_filter_status_all: "Todos los estados",
  movements_filter_incident: "Novedad",
  movements_filter_incident_all: "Todas",
  movements_filter_amount_hint:
    "El monto encuentra tanto lo que se movió en la billetera como lo que le llegó al beneficiario, sin comisión.",
  movements_col_when: "Fecha",
  movements_col_what: "Movimiento",
  movements_col_amount: "Monto",
  movements_col_incident: "Novedad",
  movements_operation_amount_out: "llegó",
  movements_operation_amount_in: "enviado",
  movements_breb_qr: "Pago con QR",
  movements_empty: "No hay movimientos",
  movements_empty_filtered: "Prueba con otros filtros o límpialos.",
  movements_total: "{{total}} movimientos",
  statement_detail_organization: "Organización",
  tx_op_coloca_refund: "Reembolso",
  entry_coloca_refund_wallet: "Reembolso de Coloca Payments",
  movements_filter_organization_hint: "Solo los movimientos de esta organización.",
};
